/* The choice of clay for free kneading (see clays.tsx), over the title screen. */

.chooser {
  position: fixed;
  inset: 0;
  display: grid;
  place-items: center;
  background: rgba(255, 246, 235, 0.55);
  backdrop-filter: blur(3px);
  z-index: 10;
}

.card {
  display: flex;
  flex-direction: column;
  gap: 10px;
  width: min(440px, calc(100vw - 32px));
  max-height: calc(100dvh - 32px);
  overflow-y: auto;
  padding: 18px 22px 20px;
  border-radius: 24px;
  background: var(--panel);
  border: 1px solid var(--line);
  box-shadow: 0 12px 40px rgba(120, 80, 50, 0.15);
  animation: rise-in 0.3s ease-out;
}

@keyframes rise-in {
  0% {
    opacity: 0;
    transform: translateY(10px) scale(0.96);
  }
  100% {
    opacity: 1;
    transform: none;
  }
}

.heading {
  margin: 0;
  font-size: 20px;
  text-align: center;
}

.lead {
  margin: 0;
  font-size: 13px;
  line-height: 1.6;
  color: var(--ink-soft);
}

.question {
  margin: 4px 0 0;
  font-size: 14px;
  font-weight: 700;
  text-align: center;
}

.clays {
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;
}

.clay {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  padding: 10px 6px 9px;
  border: 1px solid var(--line);
  border-radius: 14px;
  background: #fffaf3;
  font: inherit;
  color: var(--ink);
  cursor: pointer;
  transition: transform 0.12s, box-shadow 0.12s, border-color 0.12s;
}

/* An odd one left over at the end takes the whole row, so it does not hang to one side. */
.clay:last-child:nth-child(odd) {
  grid-column: 1 / -1;
}

.clay:hover,
.clay:focus-visible {
  transform: translateY(-2px);
  border-color: var(--accent);
  box-shadow: 0 6px 16px rgba(120, 80, 50, 0.14);
}

/* Not opened yet: shown, faded, so the player sees what clearing requests brings. */
.clay:disabled {
  opacity: 0.45;
  cursor: default;
  transform: none;
  border-color: var(--line);
  box-shadow: none;
}

.clay b {
  font-size: 14px;
}

.clay small {
  font-size: 11px;
  color: var(--ink-soft);
}

.picture {
  width: 64px;
  height: 40px;
  fill: #f2b48c;
}

.actions button {
  flex: 1;
}
